export const url = {
  getUpdateItem: '/auth/trade/inci/lastUpdateTime',
  getReleaseCountry: '/auth/releaseCountry/list',
  getInciList: '/auth/trade/inci/findList',
  getInciDetail: '/auth/trade/inci/detail',
  getRelatedBasfProduct: '/auth/trade/inci/detail/relatedBasfProduct',
  getGroupList: '/auth/brand/selectGroup',
  getBrandList: '/auth/brand/groupAndBrand',
  getInciAppAnalysis: '/auth/trade/inci/detail/INCIAppAnalysis',
  getTop10ProductContainInci: '/auth/trade/inci/detail/top10ProductContainInci',
  getConsumerProductChartData: '/auth/trade/inci/detail/consumerProsByCategoryYear',
  getRelatedFormulation: '/auth/trade/inci/relatedFormulation',
  getMoreInfoData: '/auth/trade/inci/detail/getCombineRelativeIngredient',
  getInciMoreFormulation: '/auth/trade/inci/detail/getCombineRelativeFormulation'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/ingredientClient.js